<template>
  <div class="lms-widget-grid w-full">
    <div
      v-for="n in 3"
      :key="n"
      class="flex items-center gap-3 rounded-xl border border-untitled-gray-200 bg-white p-4"
    >
      <div
        class="w-11 h-11 rounded-lg bg-untitled-gray-100 animate-pulse shrink-0"
      />
      <div class="flex-1 min-w-0">
        <div class="h-5 w-12 rounded bg-untitled-gray-100 animate-pulse" />
        <div
          class="h-3 w-24 rounded bg-untitled-gray-100 animate-pulse mt-2"
        />
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
